export default "https://cdn-static.gokick.com/assets/81b7a47639310ad105c767144326fc68b25cbb5d/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";